/** Minimo squadre per considerare un gioco "a squadre". */
export const MIN_SQUADRE_GIOCO = 2;

export function isGiocoASquadre(numeroSquadre) {
  const n = Number(numeroSquadre);
  return Number.isFinite(n) && n >= MIN_SQUADRE_GIOCO;
}

export function hasIntervalloSquadre(numeroSquadre, numeroSquadreMax) {
  const min = Number(numeroSquadre);
  const max = Number(numeroSquadreMax);
  return isGiocoASquadre(numeroSquadre) && Number.isFinite(max) && max > min;
}

export function formatNumeroSquadreLabel(numeroSquadre, numeroSquadreMax) {
  const n = Number(numeroSquadre);
  if (!Number.isFinite(n) || n < MIN_SQUADRE_GIOCO) return null;
  const max = Number(numeroSquadreMax);
  if (Number.isFinite(max) && max > n) {
    return `da ${n} a ${max} squadre`;
  }
  return n === 1 ? '1 squadra' : `${n} squadre`;
}

export function numeroSquadreForPayload(numeroSquadreRaw) {
  if (!isGiocoASquadre(numeroSquadreRaw)) return undefined;
  const n = Number(numeroSquadreRaw);
  if (Number.isFinite(n) && n >= MIN_SQUADRE_GIOCO) return Math.floor(n);
  return MIN_SQUADRE_GIOCO;
}

export function numeroSquadreMaxForPayload(
  numeroSquadreRaw,
  numeroSquadreMaxRaw
) {
  if (!isGiocoASquadre(numeroSquadreRaw)) return undefined;
  if (numeroSquadreMaxRaw === '' || numeroSquadreMaxRaw == null) {
    return undefined;
  }
  const min = Math.floor(Number(numeroSquadreRaw));
  const max = Math.floor(Number(numeroSquadreMaxRaw));
  if (!Number.isFinite(max) || max <= min) return undefined;
  return max;
}
